<template>
  <base-card :loading="pending" tabled>
    <template v-if="transfers">
      <base-table>
        <thead>
          <tr>
            <th>Seller</th>
            <th>Buyer</th>
            <th>Amount</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(transfer, key) in transfers" :key="key">
            <td>
              {{ transfer.seller.profile.firstName }} {{ transfer.seller.profile.lastName }}
              <br>
              {{ transfer.seller.email }}
            </td>
            <td>
              {{ transfer.buyer.profile.firstName }} {{ transfer.buyer.profile.lastName }}
              <br>
              {{ transfer.buyer.email }}
            </td>
            <td>{{ $formatting.toCurrency(transfer.amount) }}</td>
            <td>{{ $dates.toDateTime(transfer.createdAt) }}</td>
          </tr>
        </tbody>
      </base-table>
    </template>
    <template v-else>
      <p class="text-center">
        There are no transfers yet.
      </p>
    </template>
    <template v-if="transfers && pages > 1" v-slot:body-bottom>
      <base-pagination :current="page" :total="pages" @go="request" />
    </template>
  </base-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'InvestmentTransfers',

  data: () => ({
    page: 1
  }),

  created () {
    this.request()
  },

  computed: {
    ...mapState({
      investment: store => store.core.investments.entity,
      transfers: store => store.core.shareTransfers.rows,
      pages: store => store.core.shareTransfers.totalPages,
      pending: store => store.core.shareTransfers.isListPending
    })
  },

  methods: {
    request (page) {
      if (page) {
        this.page = page
      }

      this.getTransfers({
        page: 1,
        query: {
          investment: this.investment._id
        }
      })
    },

    ...mapActions({
      getTransfers: 'core/share-transfers/list'
    })
  }
}
</script>
